var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React from "react";
import EdButton from "@frameworks/web/components/generic/edbutton/edButton";
import "@frameworks/shared-library/stylesheets/components/SearchPanelWithPopupFiltersLabel/SearchPanelWithPopupFiltersLabel.scss";
import FundSearchPanel from "@frameworks/shared-library/components/Generic/FundSeachPanel/FundSearchPanel";
import Edelicon from "@frameworks/shared-library/components/Generic/Edelicon";
import DeviceContext from "@frameworks/shared-library/components/customHooks/indentifyDevice";
import { nanoid } from "nanoid";
import FilterLabels from "@frameworks/shared-library/components/FilterLabels/FilterLabels";
import { Overlay, Popover } from "react-bootstrap";
var uniqueIdForPop = nanoid(); //This is used to generate unique id for the popup component
var SearchPanelWithPopupFiltersLabel = function (props) {
    var _a, _b, _c;
    var device = DeviceContext();
    var _d = __read(React.useState(false), 2), isShowHiddenFilters = _d[0], setIsShowHiddenFilters = _d[1];
    var _e = __read(React.useState(0), 2), countOfHiddenFilters = _e[0], setCountOfHiddenFilters = _e[1];
    var selectedLabelsContainerRef = React.useRef(null);
    var SelectedFilters = React.useMemo(function () { return function (filterObj) {
        return (React.createElement(FilterLabels, { customLabel: filterObj.title, closeBtn: !filterObj.disable, value: filterObj.value, key: "".concat(filterObj.value, "-").concat(filterObj.subKeyName), FilterAction: function () {
                props.removeFilterThroughLabels(filterObj.value, filterObj.keyName, filterObj.subKeyName);
            }, customCloseBtn: "edel-icon-cross-bold-small" }));
    }; }, [props === null || props === void 0 ? void 0 : props.filterLabels]);
    var handleCheckForExtraFilters = function () {
        var container = selectedLabelsContainerRef === null || selectedLabelsContainerRef === void 0 ? void 0 : selectedLabelsContainerRef.current;
        var children = container === null || container === void 0 ? void 0 : container.children;
        var countSecondLine = 0;
        if (!!children && children.length) {
            var firstLineY = null;
            for (var i = 0; i < (children === null || children === void 0 ? void 0 : children.length); i++) {
                var label = children[i];
                var top_1 = label.getBoundingClientRect().top;
                if (firstLineY === null) {
                    firstLineY = top_1;
                }
                if (top_1 !== firstLineY) {
                    countSecondLine++;
                }
            }
        }
        if (countSecondLine === 0) {
            setIsShowHiddenFilters(false);
        }
        setCountOfHiddenFilters(countSecondLine);
    };
    React.useEffect(function () {
        handleCheckForExtraFilters();
    }, [(_a = props === null || props === void 0 ? void 0 : props.filterLabels) === null || _a === void 0 ? void 0 : _a.length]);
    React.useEffect(function () {
        var _a;
        if ((props === null || props === void 0 ? void 0 : props.isViewAllTrue) && (props === null || props === void 0 ? void 0 : props.isShowPopup)) {
            document.body.style.overflow = "hidden";
            (_a = document === null || document === void 0 ? void 0 : document.querySelector(".generic-full-bordered-tabs .tab-content")) === null || _a === void 0 ? void 0 : _a.scroll({ top: 100, behavior: "smooth" });
        }
        else {
            document.body.style.overflow = "hidden";
        }
    }, [props === null || props === void 0 ? void 0 : props.isShowPopup]);
    return (React.createElement("div", { className: "primary-search-panel-with-popup-filter-labels-container ".concat((_b = props.parentClassName) !== null && _b !== void 0 ? _b : "", " ").concat((device === null || device === void 0 ? void 0 : device.isDesktop)
            ? "d-flex justify-content-between align-items-center"
            : "d-flex flex-column-reverse") },
        React.createElement(FundSearchPanel, __assign({}, props, { parentClassName: props.searchBarParentClassName })),
        React.createElement("div", { className: "d-flex align-items-center gap-10" },
            React.createElement("div", { className: "".concat(!!props.filterLabels && props.filterLabels.length
                    ? "primary-filter-popup-btn-label-wrapper"
                    : "") },
                React.createElement("div", { className: "filter-popup-btn-label-container ".concat(!!props.filterLabels && props.filterLabels.length
                        ? "filters-applied d-flex align-items-center justify-content-between"
                        : "", " ").concat(isShowHiddenFilters ? "view-hidden-filters" : "", " ").concat(!isShowHiddenFilters && (props === null || props === void 0 ? void 0 : props.isShowPopup)
                        ? "filter-pop-active"
                        : "") },
                    !!props.filterLabels && props.filterLabels.length ? (React.createElement("div", { className: "d-flex justify-content-between w-100 filters-label-wrapper" },
                        React.createElement("div", { ref: selectedLabelsContainerRef, className: "selected-filters-labels-container  w-100" }, props.filterLabels.map(function (filterObj) {
                            return React.createElement(SelectedFilters, __assign({}, filterObj, { key: nanoid() }));
                        })),
                        countOfHiddenFilters ? (React.createElement(EdButton, { value: !isShowHiddenFilters
                                ? "+".concat(countOfHiddenFilters, " more")
                                : "View Less", btnTyp: "text-only", className: "text-decoration-underline txt-han-blue DMSansNormal_12_400 text-nowrap align-self-start mgt-5", onClick: function () {
                                setIsShowHiddenFilters(!isShowHiddenFilters);
                            } })) : (React.createElement(React.Fragment, null)))) : (React.createElement(React.Fragment, null)),
                    React.createElement("div", { className: "primary-filters-popup-wrapper align-self-start position-relative", id: uniqueIdForPop },
                        (props === null || props === void 0 ? void 0 : props.customFilterIcon) ? (props.customFilterIcon) : (React.createElement(EdButton, { value: React.createElement(React.Fragment, null,
                                !!props.filterLabels && props.filterLabels.length ? (React.createElement("span", { className: "filter-applied-red-dot-indicator d-flex" })) : (React.createElement(React.Fragment, null)),
                                React.createElement(Edelicon, { className: "edel-icon-curved-filter txt-han-blue ".concat((props === null || props === void 0 ? void 0 : props.isShowPopup) ? "filter-pop-active" : ""), paths: 3 })), btnTyp: "text-only", slim: true, onClick: function () {
                                !!props.setIsShowPopup &&
                                    props.setIsShowPopup(!(props === null || props === void 0 ? void 0 : props.isShowPopup));
                            }, className: "p-0 filter-icon-btn" })),
                        (props === null || props === void 0 ? void 0 : props.isShowPopup) && (React.createElement(Overlay, { flip: true, placement: "bottom-end", show: props === null || props === void 0 ? void 0 : props.isShowPopup, onHide: function () {
                                return !!props.setIsShowPopup &&
                                    props.setIsShowPopup(!(props === null || props === void 0 ? void 0 : props.isShowPopup));
                            }, target: document.getElementById(uniqueIdForPop), container: document.getElementById(uniqueIdForPop), rootClose: true, rootCloseEvent: "mousedown" },
                            React.createElement(Popover, { id: "popover-contained", className: "search-panel-filters-generic-popup removePopupTooltipArrow" },
                                React.createElement(Popover.Body, { className: "p-0" },
                                    React.createElement("div", null, props.filterComponentInsidePopup)))))))), (_c = props.rightSubComponent) !== null && _c !== void 0 ? _c : React.createElement(React.Fragment, null))));
};
export default SearchPanelWithPopupFiltersLabel;
